import { Inject, Injectable } from '@angular/core';

import {
    CommonsConfigEnvironment,
    CONFIG_ENVIRONMENT,
    CoreConfiguration,
    CoreConfigurationCategories,
    PcvizConfigurationController,
    PcvizDBRegistry,
    PcvizUploadController,
} from '@mirage-projects/cw-models';

import { DbPcvizService } from '../db/db-pcviz.service';

/**
 * Core configuration for all the applications
 */
@Injectable({ providedIn: 'root' })
export class CoreConfigurationService {
    private registryInstance!: PcvizDBRegistry;
    private configurationController!: PcvizConfigurationController;
    private uploadController!: PcvizUploadController;
    private readonly configurationFilePath = './assets/configuration/core-configuration.json';

    constructor(
        private dbPcvizService: DbPcvizService,
        @Inject(CONFIG_ENVIRONMENT) private configEnvironment: CommonsConfigEnvironment
    ) {}

    initCoreConfiguration(appName: string, envName: string): void {
        this.registryInstance = this.dbPcvizService.getInstanceDB();
        this.uploadController = this.registryInstance.getController('Upload');
        this.configurationController = this.registryInstance.getController('Configuration');
        const version = this.configEnvironment.productVersion;
        this.configurationController.fileUrl = `${this.configurationFilePath}?v=${version}`;

        if (this.configurationController) {
            this.configurationController.configApp(appName, envName);
        }

        if (this.uploadController) {
            this.uploadController.initUploadJobsFromLocalStorage();
        }
    }

    getConfig(): CoreConfiguration {
        return this.configurationController?.getConfig();
    }

    isConfigLoaded(): boolean {
        return !!this.configurationController?.isConfigLoaded();
    }

    getCategories(): CoreConfigurationCategories {
        return this.configurationController?.getCategories();
    }
}
